import PropTypes from 'prop-types';
import React from 'react';
import { Analytics, AvailabilityCalendar, MobileModal } from '../';
import styles from './AvailabilityChecker.scss';
import globalStyles from '../../globals.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../../../lib/stylesheets/SlideTransition.scss';
import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
import AvailabilityDetails from './AvailabilityDetails';
import { Icon } from 'semantic-ui-react';
import EventsHelper from '../../../lib/utils/events';
import moment from 'moment';

export default class AvailabilityChecker extends React.Component {
  static propTypes = {
    viewer: PropTypes.object.isRequired,
    mobile: PropTypes.bool,
    relay: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showAvailabilityChecker: false,
      showAvailabilityDetails: false,
      eventsOnDay: [],
      selectedDay: new Date()
    };
    this.openAvailabilityChecker = this.openAvailabilityChecker.bind(this);
    this.closeAvailabilityChecker = this.closeAvailabilityChecker.bind(this);
    this.openAvailabilityDetails = this.openAvailabilityDetails.bind(this);
    this.closeAvailabilityDetails = this.closeAvailabilityDetails.bind(this);
    this.updateSelectedDay = this.updateSelectedDay.bind(this);
  }

  componentWillMount() {
    this.props.relay.refetch({
      afterTime: moment(this.state.selectedDay)
        .startOf('month')
        .subtract(1, 'month')
        .toISOString(),
      beforeTime: moment(this.state.selectedDay)
        .startOf('month')
        .add(1, 'month')
        .toISOString(),
      returnEmptyConnection: false
    });
  }

  openAvailabilityChecker() {
    this.setState({ showAvailabilityChecker: true });
    Analytics.trackEvent('viewed-availability-checker');
  }

  closeAvailabilityChecker() {
    this.setState({ showAvailabilityChecker: false });
  }

  openAvailabilityDetails() {
    this.setState({
      showAvailabilityChecker: this.props.mobile,
      showAvailabilityDetails: true
    });
  }

  closeAvailabilityDetails() {
    this.setState({ showAvailabilityDetails: false });
  }

  updateSelectedDay(selectedDay) {
    if (!moment(this.state.selectedDay).isSame(selectedDay, 'day')) {
      this.props.relay.refetch({
        afterTime: moment(selectedDay)
          .startOf('month')
          .subtract(1, 'month')
          .toISOString(),
        beforeTime: moment(selectedDay)
          .startOf('month')
          .add(1, 'month')
          .toISOString(),
        returnEmptyConnection: false
      }, null, () => {
        this.setState({
          selectedDay,
          eventsOnDay: EventsHelper.groupEventsByDate(
            this.props.viewer.AvailabilityCheckerContainer_user_events.edges,
            selectedDay,
            this.props.viewer.s_time_zone
          )[selectedDay.getDate()]
        });
      });
    }
  }

  render() {
    const desktopTrigger = (
      <a
        className={[
          styles.calendarIcon,
          this.state.showAvailabilityChecker ? styles.calendarIconActive : ''
        ].join(' ')}
      >
        <Icon name='calendar alternate outline' />
      </a>
    );

    const mobileTrigger = (
      <a className={'item'} onClick={this.openAvailabilityChecker}>
        <i className='calendar alternate outline icon' />
      </a>
    );

    const desktopAvailabilityCalendar = (
      <AvailabilityCalendar
        initialMonth={this.state.selectedDay}
        selectedDay={this.state.selectedDay}
        onDayClick={() => {}}
        updateSelectedDay={this.updateSelectedDay}
        openAvailabilityDetails={this.openAvailabilityDetails}
        showDetails
        viewer={this.props.viewer}
      />
    );
    return (
      <div style={{ display: 'inline-block', margin: 'auto' }}>
        <div className={globalStyles.desktop}>
          <Popover
            content={desktopAvailabilityCalendar}
            interactionKind={PopoverInteractionKind.CLICK}
            popoverClassName='pt-popover-content-sizing'
            position={Position.BOTTOM}
            inline
            popoverWillOpen={this.openAvailabilityChecker}
            popoverWillClose={this.closeAvailabilityChecker}
          >
            {desktopTrigger}
          </Popover>
          <AvailabilityDetails
            isOpen={this.state.showAvailabilityDetails}
            close={this.closeAvailabilityDetails}
            closeAvailabilityChecker={this.closeAvailabilityChecker}
            eventsOnDay={this.state.eventsOnDay}
            updateSelectedDay={this.updateSelectedDay}
            selectedDay={this.state.selectedDay}
            viewer={this.props.viewer}
          />
        </div>

        <div className={globalStyles.mobile}>
          {mobileTrigger}
          <ReactCSSTransitionGroup
            transitionName='slide'
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            {this.state.showAvailabilityChecker &&
              <MobileModal
                open={this.state.showAvailabilityChecker}
                onClose={this.closeAvailabilityChecker}
                inline
              >
                <MobileModal.Header>
                  <div className='menu'>
                    <a className='item' onClick={this.closeAvailabilityChecker}>
                      <i className='left chevron icon' />
                    </a>
                  </div>
                </MobileModal.Header>
                <MobileModal.Content>
                  <AvailabilityCalendar
                    initialMonth={this.state.selectedDay}
                    selectedDay={this.state.selectedDay}
                    onDayClick={() => {}}
                    updateSelectedDay={this.updateSelectedDay}
                    viewer={this.props.viewer}
                    close={this.closeAvailabilityChecker}
                    openAvailabilityDetails={this.openAvailabilityDetails}
                    showDetails
                    mobile
                  />
                </MobileModal.Content>
              </MobileModal>}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityChecker/AvailabilityChecker.js